import { ROLE } from "../constant";

const BLOCKED_STATUSES = new Set([
  "cancelled",
  "canceled",
  "past_due",
  "unpaid",
  "incomplete_expired",
]);

/** Owner with inactive/unpaid plan — website Account only until Resubscribe. */
export function isOwnerAccessRestricted(user) {
  if (!user || user.role !== ROLE.RESTAURANT_ADMIN) return false;
  if (user.canAccessApp === false) return true;
  const status = (user.subscriptionStatus || "").toLowerCase();
  return BLOCKED_STATUSES.has(status);
}
